/**
 * @fileoverview Mixin del Centro de Ayuda con el catálogo (productos, temas y preguntas del usuario):
 * lo pide al montar y gestiona la selección de producto y tema.
 * Requiere la prop `listProducts`, help-center-navigation.mixin y help-center-tracking.mixin.
 * @module mixins/help-center-catalog.mixin
 */

import { fetchCatalog } from '@/services/help-center.service'
import { renderAnswer } from '@/utils/help-center-content'

/**
 * Marca el elemento activo de la lista. El `order + 1` es necesario: `active` no es reactivo y
 * cambiar el `:key` es lo que recrea las tarjetas para que se vean activas.
 * @param {Array<Object>} list - Productos o temas
 * @param {Object} item - Elemento activo
 */
function activateItem (list, item) {
  list.forEach(entry => {
    entry.order = entry.order + 1
    entry.active = entry === item
  })
}

export default {
  data () {
    return {
      showCDA: false,
      products: [],
      topics: [],
      questions: [],
      questionsAll: [],
      questionKey: 0,
      questionActive: '',
      productActive: ''
    }
  },
  mounted () {
    this.loadCatalog()
  },
  methods: {
    /**
     * Pide el catálogo. Si la petición falla se muestra el Centro de Ayuda sin productos
     * en vez de dejar el loader a pantalla completa para siempre.
     */
    loadCatalog () {
      return fetchCatalog(this.listProducts).then(
        products => this.onCatalogLoaded(products),
        () => this.onCatalogLoaded([])
      )
    },

    /** Guarda el catálogo y abre el primer producto (siempre en desktop; en móvil solo si hay uno). */
    onCatalogLoaded (products) {
      this.products = Array.isArray(products) ? products : []
      this.showCDA = true
      if (!this.products.length) return
      if (!this.mobile || this.products.length === 1) this.selectProduct(this.products[0].code)
    },

    /**
     * Activa un producto y prepara sus temas y preguntas (cada respuesta se sanitiza una sola vez).
     * @param {string} code - Código del producto
     */
    selectProduct (code) {
      const product = this.products.find(item => item.code === code)
      if (!product) return
      activateItem(this.products, product)
      this.productActive = product.name
      this.topics = product.topics
      this.questionsAll = product.questions
      this.questionsAll.forEach(question => {
        if (question.format) return
        question.response = renderAnswer(question.response)
        question.format = true
      })
      const firstTopic = this.topics[0]
      if (firstTopic && (this.mobile || this.products.length === 1)) this.showTopic(firstTopic.id)
    },

    /** Abre un tema de la lista. En móvil solo avanza de paso: la selección ocurre al tocar el menú. */
    showTopic (topicId) {
      if (!this.mobile) this.selectMenu(topicId)
      this.goTopics()
    },

    /** Selecciona un tema, muestra sus preguntas y registra "click topic". */
    selectMenu (topicId) {
      const topic = this.topics.find(item => item.id === topicId)
      if (!topic) return
      this.questionKey += 1
      activateItem(this.topics, topic)
      this.questions = this.questionsAll.filter(item => item.topicId === topicId)
      this.questionActive = this.questions[0].id
      this.trackTopic(topic.name)
      this.goQuestions(topic.name)
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/help-center-catalog.mixin.js